import React from "react";
import { api, state } from "../interfaces/interfaces";
import { useAppSelector } from "../store/hooks";
import { debouncedAction, getISODate } from "@utils/general/index";
import { dispatchSetState } from "../reducers/stateReducer";
import AddressUtils from "@utils/address";
import { applyChargeRateDiscount } from "@utils/charges";

// async function to get charges from the server
export const getCharges = async (
    accountCode: number,
    postcode: string,
    jobTypeCode: string,
    dateTimeRequired: Date,
    isCommercial: boolean,
    callTypeId?: number) => {

    //if conditions have changed, get charges from the server
    const current = { ...state.Conditions };
    // check if instance of Date
    if (current && !(current.dateTimeRequired instanceof Date) && current.dateTimeRequired) {
        current.dateTimeRequired = new Date(current.dateTimeRequired);
    }
    if (current && accountCode === current.accountCode && postcode === current.postcode && jobTypeCode === current.jobTypeCode && dateTimeRequired.getTime() === current.dateTimeRequired?.getTime() && isCommercial === current.isCommercial) {
        return;
    }

    //set conditions in state
    dispatchSetState("Conditions", {
        accountCode,
        dateTimeRequired,
        isCommercial,
        jobTypeCode,
        postcode,
    })

    // callTypeId from job object
    if (callTypeId !== 2 && callTypeId !== 3) {
        const currentCharge = state.Charge?.trace
        const response = await api.fetchGetCharges({
            callTypeId,
            accountCode,
            postcode,
            jobTypeCode,
            dateTimeRequired: getISODate(dateTimeRequired),
            quantity: 0,
            options: "",
            isCommercial,
            discountedRate: 0,
        })

        // if response length is greater than 0, set charges in state
        if (response?.length > 0) {
            const newRate = response[0].trace;

            if (newRate !== currentCharge) {
                // set charges to data if data is not null otherwise set charges to empty array
                // setCharges && setCharges(response ? response : []);
                state.Charge = response[0];
            }
            debouncedAction(async () => applyChargeRateDiscount(), "applyCharges", 10); // re-apply discounts to charges
        }
    }
}

// react-hook useCharges to get charges asynchronously from the server
const useCharges = () => {
    const charges = useAppSelector(({ state }) => state.Charge)
    //get postcode from ui store
    const postcode = useAppSelector(({ ui }) => ui.PropertyAddressPostcode);
    // get accountCode from state store
    const accountCode = useAppSelector(({ state }) => state.Account);
    // get isBusiness from ui store
    const isCommercial = useAppSelector(({ ui }) => ui.PropertyAddressIsBusiness);
    // get jobTypeCode from ui store
    const job = useAppSelector(({ ui }) => ui.ProblemComboJob);
    // get callTypeId from state store
    const callTypeId = useAppSelector(({ state }) => state.CallTypeId);
    // get appointmentDate from ui store as 
    const appointmentDate = useAppSelector(({ ui }) => ui.AppointmentDate);

    // useEffect to get charges on mount
    React.useEffect(() => {
        // if (!isMount) {
        if (job?.jobTypeCode && accountCode?.accountCode && appointmentDate && AddressUtils.validatePostcode(postcode)) {
            let dateTimeRequired = new Date(appointmentDate as Date);
            // if dateTimeRequired is not of type Date convert to date
            if (!(dateTimeRequired instanceof Date)) {
                dateTimeRequired = new Date(dateTimeRequired);
            }
            debouncedAction(() => getCharges(accountCode?.accountCode ?? 44999, postcode, job.jobTypeCode, dateTimeRequired, isCommercial, callTypeId), "getCharges", 50);
        }
        // }
    }, [accountCode, appointmentDate, callTypeId, isCommercial, job, postcode]);

    React.useEffect(() => {
        debouncedAction(async () => applyChargeRateDiscount(), "applyCharges", 10);
    }, [charges]);

    return charges;
}

export default useCharges;